import { Checkbox } from '@talentmesh/ui/components/checkbox';
import { Label } from '@talentmesh/ui/components/label';
import { RadioGroup, RadioGroupItem } from '@talentmesh/ui/components/radio-group';
import { cn } from '@talentmesh/ui/lib/utils';
import { memo, CSSProperties } from 'react';

export interface CustomMenuItemWithValueProps {
    id: string;
    menuItemLabel: string;
    selected: boolean;
    changeCallback: () => void;
}

export interface CheckboxRowProps extends CustomMenuItemWithValueProps {
    style?: CSSProperties;
    isRadio?: boolean;
    className?: string;
}

function CheckboxRow({ id, menuItemLabel, selected, changeCallback, style, isRadio, className }: CheckboxRowProps) {
    return (
        <div key={id} className={cn('flex items-center gap-2.5 px-2.5', className)} style={style}>
            {isRadio ? (
                <RadioGroup className="w-fit" value={selected?.toString()}>
                    <RadioGroupItem id={id} value="true" onClick={changeCallback} />
                </RadioGroup>
            ) : (
                <Checkbox id={id} checked={selected} onCheckedChange={() => changeCallback()} />
            )}
            <Label htmlFor={id} className="text-sm font-normal">
                {menuItemLabel}
            </Label>
        </div>
    );
}

export default memo(CheckboxRow);
